import axios from "axios"
import { toast } from "react-toastify";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL


export const CreateSettlement=async(formData)=>{
    console.log(formData);
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/settlement`,formData);
        if(responce==="OK"){
            toast.success("Added")
        }
        return responce
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetSettlement =async()=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/settlement`);
        return responce;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetByIdSettlement =async(amdno)=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/settlement/${amdno}`);
        return responce.data;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const updateSettlement = async(formData)=>{
    try{
        const responce = await axios.patch(`${BACKEND_URL}/api/settlement`,formData)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const CheckAmdNo = async(formData)=>{
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/settlement/check/${formData}`)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}